module.exports = __webpack_public_path__ + "components/flag/static/square/ky-4ef3efe1de848c744dadc0d53fe61619.svg";